export default "__VITE_ASSET__Dh3_XUDC__"